import { Component } from '@angular/core';
import { SHARED_IMPORTS } from '../../shared/standalone-imports';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
  standalone: true,
  imports: [...SHARED_IMPORTS],
})
export class MaintenanceComponent {
  public reloadPage() {
    location.href = "/"
  }
}
